<template>
  <CRow>
    <CCol col="12" lg="12">
      <CCard>
        <CCardBody>
          <h3 v-if="isEditing">
            {{ $t('button.edit') }} {{ $tc('users.label', 1) }}
          </h3>
          <h3 v-else>{{ $t('button.create') }} {{ $tc('users.label', 1) }}</h3>
          <div class="row">
            <div class="col-6">
              <CSelect
              :label="$t('fields.employee')" 
              :value.sync="user.employee_id"
              :plain="true"
              :options="employees"
              :placeholder="$t('fields.employee_placeholder')"
            >
            </CSelect>
            </div>
            <div class="col-6">
              <CInput 
              :label="$t('fields.username')" 
              type="text" 
              placeholder="Ex: jperez" 
              v-model="user.username"
              @keyup="checkUsername()">
              </CInput>
              <span :class="[isAvailable ? 'notavailable' : 'available']">{{ username_response }}</span>
            </div>
          </div>
          <div class="row">
            <div class="col-6">
              <CInput :label="$t('fields.password')" type="password" placeholder="" v-model="user.password"></CInput>
            </div>
            <div class="col-6">
              <CInput :label="$t('fields.password_confirmation')" type="password" placeholder="" v-model="user.password_confirmation"></CInput>
            </div>
          </div>
          <div class="row">
            <div class="col-4">
              <CInput :label="$t('fields.email')" type="email" :placeholder="$t('fields.email_placeholder')" v-model="user.email"></CInput>
            </div>
            <div class="col-4">
              <CSelect label="Role" :placeholder="$t('fields.role_placeholder')" :value.sync="user.role_id" :options="roles"></CSelect>
            </div>
            <div class="col-4">
              <CSelect
              :label="$t('fields.is_active')"
              :value.sync="user.status"
              :plain="true"
              :options="statuses"
              :placeholder="$t('fields.status_placeholder')"
              >
              </CSelect>
            </div>
          </div>
          <CButton color="success" @click="saveData()">
            <template v-if="isEditing"><CIcon :content="$options.updateIcon" /> {{ $t('button.update') }}</template>
            <template v-else><CIcon :content="$options.addIcon" /> {{ $t('button.create') }}</template>
            </CButton>
          <CButton color="primary" @click="goBack()"><CIcon :content="$options.backIcon" /> {{ $t('button.back') }}</CButton>
        </CCardBody>
      </CCard>
    </CCol>
  </CRow>
</template>

<script>
import axios from 'axios';
import formMixin from "../../mixins/form";
import localeMixin from '../../mixins/locale'; // Order matters, mixin first then i18n.
import i18n from "../../i18n";
import { cilSync, cilPlus, cilArrowLeft } from '@coreui/icons';

export default {
  name: 'FormUser',
  mixins: [formMixin, localeMixin],
  addIcon: cilPlus,
  updateIcon: cilSync,
  backIcon: cilArrowLeft,
  data() {
    return {
        user: {
          employee_id: '',
          username: '',
          email: '',
          password: '',
          password_confirmation: '',
          role_id: '',  
          status: ''
        },
        username_response: '',
        isAvailable: 0,
        roles: [],
        employees: [],
        statuses: [
          {
            label: i18n.t('fields.active'),
            value: "1"
          },
          {
            label: i18n.t('fields.inactive'),
            value: "0"
          }
        ],
        message: ''
    }
  },
  computed: {
      isDisabled() {
          if (!this.isEditing) {
              return this.isAvailable ? true : false;
          }
      }
  },
  mounted() {
    if (this.isEditing) {
        this.getUser();
    }
    this.getEmployees();
    this.getRoles();
  },
  methods: {
    goBack() {
      this.$router.push({ name: 'Users' });
    },
    showAlert(type, msg) {
      let title = '';
      let body = '';
      let status = '';
      let redirect = true;

      switch(type) {
        case 'add':
          title = i18n.t('users.modal.created_label');
          body = i18n.t('users.modal.created_body');
          status = 'success';
          break;
        case 'edit':
          title = i18n.t('users.modal.updated_label');
          body = i18n.t('users.modal.updated_body');
          status = 'success';
          break;
        case 'error':
          title = 'Error';
          body = msg;
          status = 'danger';
          redirect = false;
          break;
      }

      this.$swal(
        title,
        body,
        status
      ).then(result => {
        if (redirect) {
          this.goBack();
        }
      });
    },
    saveData() {
        // const data = formData || this.prepareObjectData();
        const data = this.user;
        this.$emit("saved", data);
        let url = `/api/users`;
        let sendRequest = null;

        if (this.isEditing) {
            url = url + "/" + this.$route.params.id + '?token=' + localStorage.getItem("api_token");
            sendRequest = async() => {
                try {
                    const response = await axios.put(url, data);
                    if (response.data.status === "success") {
                        this.showAlert('edit');
                    }
                } catch (error) {
                    if(error.response.data.message == 'The given data was invalid.'){
                        this.message = '';
                        for (let key in error.response.data.errors) {
                            if (error.response.data.errors.hasOwnProperty(key)) {
                                this.message += error.response.data.errors[key][0] + '<br>';
                            }
                        }
                        this.showAlert('error', this.message);
                    } else{
                        console.error(error);
                        this.showAlert('error', error);
                    }
                }
            };
        } else {
            // the result is swaped
            if (this.isAvailable) {
                return;
            }
            url = url + '?token=' + localStorage.getItem("api_token");
            sendRequest = async() => {
                try {
                    const response = await axios.post(url, data);
                    if (response.data.status === "success") {
                        this.showAlert('add');
                    }
                    console.log(response);
                } catch (error) {
                    if(error.response.data.message == 'The given data was invalid.') {
                        this.message = '';
                        for (let key in error.response.data.errors) {
                            if (error.response.data.errors.hasOwnProperty(key)) {
                                this.message += error.response.data.errors[key][0] + '<br>';
                            }
                        }
                        this.showAlert('error', this.message);
                    } else{
                        console.error(error);
                        this.showAlert('error', error);
                    }
                }
            };
        }
        sendRequest();
        return data;
    },
    getUser() {
        const id = this.$route.params.id;
        axios.get('/api/users/'+ id + '?token=' + localStorage.getItem("api_token"))
        .then(response => {
            this.user = response.data;
            this.user.status_class = this.user.status ? "primary" : "secondary";
        }).catch(error => {
            console.log(error);
            this.$router.push({ path: '/login' });
        });
    },
    getRoles() {
      axios.get('/api/roles?token=' + localStorage.getItem('api_token'))
      .then(response => {
        const data = response.data;
        data.forEach(elem => {
          this.roles.push({
            label: elem.name,
            value: elem.id
          });
        });

      }).catch(error => {
        console.log(error);
        this.$router.push({ path: '/login' });
      });
    },
    getEmployees() {
        axios.get('/api/employees?token=' + localStorage.getItem("api_token"))
        .then(response => {
            const data = response.data;
            data.forEach(elem => {
                this.employees.push({
                    label: elem.name,
                    value: elem.id
                });
            });
        }).catch(error => {
            console.log(error);
            this.$router.push({ path: '/login' });
        });
    },
    checkUsername() {
        const username = this.user.username.trim();
        axios.post('/api/users/checkUsername/'+ username + '?token=' +localStorage.getItem('api_token'))
        .then(response => {
            const data = response.data;
            this.isAvailable = data.result;
            this.username_response = data.message;
        }).catch(error => {
            console.log(error);
        });
    }
  }
}

</script>

<style lang="scss" scoped>
.available {
    color: green;
}
.notavailable {
    color: red;
}
</style>
